// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Common - Start **/
.VideoSearchForm-btn-L4LsX {
	padding: 11px 21px;
	border-color: var(--primary-border);
	background: var(--primary-white-bg);
	color: var(--common-text-color);
	font-weight: bold;
	font-size: 14px;
}
.VideoSearchForm-btnBlock-imuoB {
	width: 100%;
	position: relative;
	white-space: normal;
	display: block;
	font-size: 18px;
	border-radius: 6px;
	font-weight: 500;
	-webkit-box-shadow: 0px 8px 11px #31313126;
	        box-shadow: 0px 8px 11px #31313126;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}
.VideoSearchForm-btn-L4LsX:hover,
.VideoSearchForm-btn-L4LsX:focus,
.VideoSearchForm-btn-L4LsX:hover:focus {
	background: var(--primary-white-bg);
	color: var(--common-text-color);
}
.VideoSearchForm-btnPrimary-j0cTu {
	border-color: var(--btn-primary-bg) !important;
	background-color: var(--btn-primary-bg) !important;
	color: var(--white-text);
}
.VideoSearchForm-btnPrimary-j0cTu:hover,
.VideoSearchForm-btnPrimary-j0cTu:focus,
.VideoSearchForm-btnPrimary-j0cTu:active,
.VideoSearchForm-btnPrimary-j0cTu:active:hover,
.VideoSearchForm-btnPrimary-j0cTu:active:focus {
	border-color: var(--btn-primary-bg-hover) !important;
	background-color: var(--btn-primary-bg-hover) !important;
	color: var(--white-text) !important;
	outline: 0 !important;
}
.VideoSearchForm-btnPrimaryBorder-vDMwx {
	border-color: var(--btn-primary-bg);
	color: var(--btn-primary-bg);
	background-color: var(--primary-white-bg);
}
.VideoSearchForm-btnPrimaryBorder-vDMwx:hover,
.VideoSearchForm-btnPrimaryBorder-vDMwx:focus,
.VideoSearchForm-btnPrimaryBorder-vDMwx:active,
.VideoSearchForm-btnPrimaryBorder-vDMwx:active:hover,
.VideoSearchForm-btnPrimaryBorder-vDMwx:active:focus {
	border-color: var(--btn-primary-bg-hover);
	color: var(--btn-primary-bg-hover);
	background-color: var(--primary-white-bg);
}
.VideoSearchForm-formControlSelect-vOB0m {
	height: 40px;
	border-radius: 2px;
	margin-bottom: 8px;
	font-size: 14px;
	max-width: 100%;
	border: none;
	background-color: var(--primary-white-bg);
	color: var(--modalText-color);
	line-height: 24px;
	display: block;
	overflow: hidden;
	-webkit-appearance: none;
	   -moz-appearance: none;
	        appearance: none;
}
.VideoSearchForm-noPadding-LZSMF {
	padding: 0px !important;
}
/** Common - End **/
/** Search Form - Start **/
.VideoSearchForm-tableCell-dYkGE {
	padding: 25px 0 0;
	vertical-align: middle;
	margin: 0;
}
.VideoSearchForm-location-dGirB,
.VideoSearchForm-dates-oW9XH {
	width: 100%;
}
.VideoSearchForm-guests-LxgdN {
	width: 100%;
}
.VideoSearchForm-search-ID1dI {
	margin: 27px 0 0;
}
.VideoSearchForm-label-zRLNI {
	margin: 0 0 10px;
	white-space: nowrap;
	font-weight: 500;
	color: var(--common-text-color);
	letter-spacing: 0.1px;
}
.VideoSearchForm-formControlInput-d0krB {
	padding: 10px 35px 10px 10px;
	height: 40px;
	border-radius: 2px;
	font-size: 14px;
	border: 1px solid var(--primary-border);
	background-color: var(--primary-white-bg);
	color: var(--modalText-color);
}
.VideoSearchForm-loadfield-L0Qdj {
	border: 1px solid var(--primary-border) !important;
	padding: 0 20px !important;
	border-radius: 60px !important;
	height: 45px;
	font-weight: normal !important;
	font-size: 14px !important;
	letter-spacing: 0px !important;
	color: var(--common-text-color) !important;
	-webkit-box-shadow: 0 1px 15px 3px #eeebeb !important;
	        box-shadow: 0 1px 15px 3px #eeebeb !important;
}
@media screen and (max-width: 767px) {

	.VideoSearchForm-location-dGirB,
	.VideoSearchForm-dates-oW9XH,
	.VideoSearchForm-guests-LxgdN {
		width: 100%;
	}

	.VideoSearchForm-tableCell-dYkGE {
		border-right: 0px;
		display: block;
	}

	.VideoSearchForm-tableCell-dYkGE:not(first-child) {
		border-right: inherit;
	}
}
@media screen and (max-width: 640px) {
	.VideoSearchForm-selectPadding-wA6vb {
		padding: 0px;
	}

	.VideoSearchForm-btnBlock-imuoB {
		font-size: 18px;
	}
}
.VideoSearchForm-geoSuggestContainer-x1kvA {
	width: 100% !important;
	margin: 0px !important;
}
@media (max-width: 350px) {
	.VideoSearchForm-tableCell-dYkGE {
		padding: 5px 0 0;
	}

	.VideoSearchForm-label-zRLNI {
		margin: 0 0 5px;
	}
}
.VideoSearchForm-searchElement-eroXh {
	display: block !important;
	margin-bottom: 0px;
}
/** Search Form - End **/`, "",{"version":3,"sources":["webpack://./src/components/Home/VideoSearchForm/VideoSearchForm.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;CACC,kBAAkB;CAClB,mCAAmC;CACnC,mCAAmC;CACnC,+BAA+B;CAC/B,iBAAiB;CACjB,eAAe;AAChB;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,0CAAkC;SAAlC,kCAAkC;CAClC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;AAEA;;;CAGC,mCAAmC;CACnC,+BAA+B;AAChC;AAEA;CACC,8CAA8C;CAC9C,kDAAkD;CAClD,wBAAwB;AACzB;AAGA;;;;;CAKC,oDAAoD;CACpD,wDAAwD;CACxD,mCAAmC;CACnC,qBAAqB;AACtB;AAEA;CACC,mCAAmC;CACnC,4BAA4B;CAC5B,yCAAyC;AAC1C;AAEA;;;;;CAKC,yCAAyC;CACzC,kCAAkC;CAClC,yCAAyC;AAC1C;AAGA;CACC,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,YAAY;CACZ,yCAAyC;CACzC,6BAA6B;CAC7B,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;AACjB;AAEA;CACC,uBAAuB;AACxB;AAEA,mBAAmB;AAEnB,0BAA0B;AAE1B;CACC,iBAAiB;CACjB,sBAAsB;CACtB,SAAS;AACV;AAEA;;CAEC,WAAW;AACZ;AAEA;CACC,WAAW;AACZ;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;CAChB,+BAA+B;CAC/B,qBAAqB;AACtB;AAEA;CACC,4BAA4B;CAC5B,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,uCAAuC;CACvC,yCAAyC;CACzC,6BAA6B;AAC9B;AAEA;CACC,kDAAkD;CAClD,0BAA0B;CAC1B,8BAA8B;CAC9B,YAAY;CACZ,8BAA8B;CAC9B,0BAA0B;CAC1B,8BAA8B;CAC9B,0CAA0C;CAC1C,qDAA6C;SAA7C,6CAA6C;AAC9C;AAEA;;CAEC;;;EAGC,WAAW;CACZ;;CAEA;EACC,iBAAiB;EACjB,cAAc;CACf;;CAEA;EACC,qBAAqB;CACtB;AACD;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,eAAe;CAChB;AACD;AAEA;CACC,sBAAsB;CACtB,sBAAsB;AACvB;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,eAAe;CAChB;AACD;AAEA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;AAEA,wBAAwB","sourcesContent":["/** Common - Start **/\n.btn {\n\tpadding: 11px 21px;\n\tborder-color: var(--primary-border);\n\tbackground: var(--primary-white-bg);\n\tcolor: var(--common-text-color);\n\tfont-weight: bold;\n\tfont-size: 14px;\n}\n\n.btnBlock {\n\twidth: 100%;\n\tposition: relative;\n\twhite-space: normal;\n\tdisplay: block;\n\tfont-size: 18px;\n\tborder-radius: 6px;\n\tfont-weight: 500;\n\tbox-shadow: 0px 8px 11px #31313126;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.btn:hover,\n.btn:focus,\n.btn:hover:focus {\n\tbackground: var(--primary-white-bg);\n\tcolor: var(--common-text-color);\n}\n\n.btnPrimary {\n\tborder-color: var(--btn-primary-bg) !important;\n\tbackground-color: var(--btn-primary-bg) !important;\n\tcolor: var(--white-text);\n}\n\n\n.btnPrimary:hover,\n.btnPrimary:focus,\n.btnPrimary:active,\n.btnPrimary:active:hover,\n.btnPrimary:active:focus {\n\tborder-color: var(--btn-primary-bg-hover) !important;\n\tbackground-color: var(--btn-primary-bg-hover) !important;\n\tcolor: var(--white-text) !important;\n\toutline: 0 !important;\n}\n\n.btnPrimaryBorder {\n\tborder-color: var(--btn-primary-bg);\n\tcolor: var(--btn-primary-bg);\n\tbackground-color: var(--primary-white-bg);\n}\n\n.btnPrimaryBorder:hover,\n.btnPrimaryBorder:focus,\n.btnPrimaryBorder:active,\n.btnPrimaryBorder:active:hover,\n.btnPrimaryBorder:active:focus {\n\tborder-color: var(--btn-primary-bg-hover);\n\tcolor: var(--btn-primary-bg-hover);\n\tbackground-color: var(--primary-white-bg);\n}\n\n\n.formControlSelect {\n\theight: 40px;\n\tborder-radius: 2px;\n\tmargin-bottom: 8px;\n\tfont-size: 14px;\n\tmax-width: 100%;\n\tborder: none;\n\tbackground-color: var(--primary-white-bg);\n\tcolor: var(--modalText-color);\n\tline-height: 24px;\n\tdisplay: block;\n\toverflow: hidden;\n\tappearance: none;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n/** Common - End **/\n\n/** Search Form - Start **/\n\n.tableCell {\n\tpadding: 25px 0 0;\n\tvertical-align: middle;\n\tmargin: 0;\n}\n\n.location,\n.dates {\n\twidth: 100%;\n}\n\n.guests {\n\twidth: 100%;\n}\n\n.search {\n\tmargin: 27px 0 0;\n}\n\n.label {\n\tmargin: 0 0 10px;\n\twhite-space: nowrap;\n\tfont-weight: 500;\n\tcolor: var(--common-text-color);\n\tletter-spacing: 0.1px;\n}\n\n.formControlInput {\n\tpadding: 10px 35px 10px 10px;\n\theight: 40px;\n\tborder-radius: 2px;\n\tfont-size: 14px;\n\tborder: 1px solid var(--primary-border);\n\tbackground-color: var(--primary-white-bg);\n\tcolor: var(--modalText-color);\n}\n\n.loadfield {\n\tborder: 1px solid var(--primary-border) !important;\n\tpadding: 0 20px !important;\n\tborder-radius: 60px !important;\n\theight: 45px;\n\tfont-weight: normal !important;\n\tfont-size: 14px !important;\n\tletter-spacing: 0px !important;\n\tcolor: var(--common-text-color) !important;\n\tbox-shadow: 0 1px 15px 3px #eeebeb !important;\n}\n\n@media screen and (max-width: 767px) {\n\n\t.location,\n\t.dates,\n\t.guests {\n\t\twidth: 100%;\n\t}\n\n\t.tableCell {\n\t\tborder-right: 0px;\n\t\tdisplay: block;\n\t}\n\n\t.tableCell:not(first-child) {\n\t\tborder-right: inherit;\n\t}\n}\n\n@media screen and (max-width: 640px) {\n\t.selectPadding {\n\t\tpadding: 0px;\n\t}\n\n\t.btnBlock {\n\t\tfont-size: 18px;\n\t}\n}\n\n.geoSuggestContainer {\n\twidth: 100% !important;\n\tmargin: 0px !important;\n}\n\n@media (max-width: 350px) {\n\t.tableCell {\n\t\tpadding: 5px 0 0;\n\t}\n\n\t.label {\n\t\tmargin: 0 0 5px;\n\t}\n}\n\n.searchElement {\n\tdisplay: block !important;\n\tmargin-bottom: 0px;\n}\n\n/** Search Form - End **/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `VideoSearchForm-btn-L4LsX`,
	"btnBlock": `VideoSearchForm-btnBlock-imuoB`,
	"btnPrimary": `VideoSearchForm-btnPrimary-j0cTu`,
	"btnPrimaryBorder": `VideoSearchForm-btnPrimaryBorder-vDMwx`,
	"formControlSelect": `VideoSearchForm-formControlSelect-vOB0m`,
	"noPadding": `VideoSearchForm-noPadding-LZSMF`,
	"tableCell": `VideoSearchForm-tableCell-dYkGE`,
	"location": `VideoSearchForm-location-dGirB`,
	"dates": `VideoSearchForm-dates-oW9XH`,
	"guests": `VideoSearchForm-guests-LxgdN`,
	"search": `VideoSearchForm-search-ID1dI`,
	"label": `VideoSearchForm-label-zRLNI`,
	"formControlInput": `VideoSearchForm-formControlInput-d0krB`,
	"loadfield": `VideoSearchForm-loadfield-L0Qdj`,
	"selectPadding": `VideoSearchForm-selectPadding-wA6vb`,
	"geoSuggestContainer": `VideoSearchForm-geoSuggestContainer-x1kvA`,
	"searchElement": `VideoSearchForm-searchElement-eroXh`
};
module.exports = ___CSS_LOADER_EXPORT___;
